import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';

export interface IMobileBuild {
    appBuildVersion: string;
    appDownloadURL: string;
    appFileDescription: string;
    appFileDisplayName: string;
    appFileName: string;
    appId: string;
    appName: string;
    appType: string;
    appVersion: string;
    buildFailedErrorMessage: string;
    buildRequestDetails: string;
    buildRequestId: string;
    buildRequestedBy: string;
    buildRequestedDate: string;
    buildStatus: number
    isSystemAutorequested: string;
    noOfTimesDownloaded: string;
}

export const useGetMobileBuildQuery = (appId: string) => {
    const { getData } = useServiceClient();
    const getMobileBuild = React.useCallback(() => getData(`${MyAppsEndPoints.GET_MOBILE_BUILD}/${appId}`).then((res) => res.json()), [appId, getData]);
    return useQuery<IMobileBuild[]>(MyAppsQueryKey.GET_MOBILE_BUILD, getMobileBuild, { cacheTime: 0, notifyOnChangeProps: 'tracked' });
};
